import CompanyObject from './CompanyObject/CompanyObject';
import CompanyTitle from './CompanyTitle/CompanyTitle';
import style from './HeroSection.module.css';
import { useState } from 'react';

const HeroSection = ({}) => {
  return (
    <>
      <div className={style.heroContainer} id="home">
        <CompanyTitle />
        <CompanyObject />
      </div>
    </>
  );
};

export default HeroSection;
